// extracted by mini-css-extract-plugin
module.exports = {"persistentRecordButton":"record-button_persistentRecordButton_22U"};